import {
  $serializer_getInstance1xzjfnlwwk6fk as $serializer_getInstance,
  $serializer_getInstance1qlvq11on0v1u as $serializer_getInstance_0,
  IDjecfjjw6mot9 as ID,
  $serializer_getInstance1a39stva24llm as $serializer_getInstance_1,
  ID__hashCode_impl_f4lulzhgc2u8u1q7v1 as ID__hashCode_impl_f4lulz,
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance_2,
  IDqqik72jjbpsn as ID_0,
  ID__toString_impl_y5caka2oopvpysxo85x as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulzrhf9x0v3ec95 as ID__hashCode_impl_f4lulz_0,
  $serializer_getInstance1t4tj96m79rxb as $serializer_getInstance_3,
  ID1m87d1hextx54 as ID_1,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance_4,
  ID__hashCode_impl_f4lulz1y71t598eu6qn as ID__hashCode_impl_f4lulz_1,
} from './domain.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  $serializer_getInstance2ga0n7x7no2vd as $serializer_getInstance_5,
  $serializer_getInstanceva225auct2k8 as $serializer_getInstance_6,
} from './types.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  AdminViewOnlyyhkyako4fc99 as AdminViewOnly,
  References31yy1vpluik8j as References,
  AdminTitleFields1r7jr8w0z0gjc as AdminTitleFields,
  AdminTableColumns127mx0x3shj3w as AdminTableColumns,
  NaturalSort21fbc8xpuy7g0 as NaturalSort,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { $serializer_getInstances2uba6hlovkk as $serializer_getInstance_7 } from './models.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { now2qufyxzn5e863 as now } from './clock.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function FamilyApplication$Submission$Companion$$childSerializers$_anonymous__bhls9y() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, lazy(tmp_0, FamilyApplication$Submission$Companion$$childSerializers$_anonymous__bhls9y)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyApplication.Submission', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('submittedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.addElement_5pzumi_k$('children', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_kb5b43_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.submittedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_5(), value.submittedAt_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_0(), value.family_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.children_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kb5b43_k$(encoder, value instanceof Submission() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Submission().new_org_thecommunitygroupinc_cares_FamilyApplication_Submission_h7qzzy_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_5()), $serializer_getInstance_0(), tmp0_cached[2].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_8() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyApplication.Review', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('reviewedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('approved', false);
        tmp0_serialDesc.addElement_5pzumi_k$('resultingFamily', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_iuqd5b_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.reviewedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_5(), value.reviewedAt_1);
        }
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.approved_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          var tmp_0 = value.resultingFamily_1;
          tmp = !((tmp_0 == null ? null : new (ID())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_1();
          var tmp_2 = value.resultingFamily_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new (ID())(tmp_2));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_iuqd5b_k$(encoder, value instanceof Review() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = $serializer_getInstance_1();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_2 = $serializer_getInstance_1();
                var tmp_3 = tmp6_local2;
                var tmp_4 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
                tmp6_local2 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Review().new_org_thecommunitygroupinc_cares_FamilyApplication_Review_fnqt1j_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_5()), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_1())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_9() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka_0($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.FamilyApplication.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(FamilyApplication())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_aud5mo_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_aud5mo_k$(encoder, value instanceof ID_2() ? value.raw_1 : THROW_CCE());
      }
      deserialize_xjvfs7_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_2())(this.deserialize_xjvfs7_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_10() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_2($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_2()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_2())(other instanceof ID_2() ? other.raw_1 : THROW_CCE()));
}
function FamilyApplication$Companion$$childSerializers$_anonymous__ysr276() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_7());
}
var SubmissionClass;
function Submission() {
  if (SubmissionClass === VOID) {
    class $ {
      constructor(submittedAt, family, children) {
        Companion_getInstance_0();
        submittedAt = submittedAt === VOID ? null : submittedAt;
        this.submittedAt_1 = submittedAt;
        this.family_1 = family;
        this.children_1 = children;
      }
      copy_r2yjr6_k$(submittedAt, family, children) {
        return new (Submission())(submittedAt, family, children);
      }
      copy$default_100iqh_k$(submittedAt, family, children, $super) {
        submittedAt = submittedAt === VOID ? this.submittedAt_1 : submittedAt;
        family = family === VOID ? this.family_1 : family;
        children = children === VOID ? this.children_1 : children;
        return $super === VOID ? this.copy_r2yjr6_k$(submittedAt, family, children) : $super.copy_r2yjr6_k$.call(this, submittedAt, family, children);
      }
      toString() {
        return 'Submission(submittedAt=' + toString_0(this.submittedAt_1) + ', family=' + this.family_1.toString() + ', children=' + toString(this.children_1) + ')';
      }
      hashCode() {
        var result = this.submittedAt_1 == null ? 0 : this.submittedAt_1.hashCode();
        result = imul(result, 31) + this.family_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.children_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Submission()))
          return false;
        if (!equals(this.submittedAt_1, other.submittedAt_1))
          return false;
        if (!this.family_1.equals(other.family_1))
          return false;
        if (!equals(this.children_1, other.children_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyApplication_Submission_h7qzzy_k$(seen0, submittedAt, family, children, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.submittedAt_1 = null;
        else
          $this.submittedAt_1 = submittedAt;
        $this.family_1 = family;
        $this.children_1 = children;
        return $this;
      }
    }
    initMetadataForClass($, 'Submission', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    SubmissionClass = $;
  }
  return SubmissionClass;
}
var ReviewClass;
function Review() {
  if (ReviewClass === VOID) {
    class $ {
      constructor(reviewedAt, approved, resultingFamily) {
        reviewedAt = reviewedAt === VOID ? null : reviewedAt;
        resultingFamily = resultingFamily === VOID ? null : resultingFamily;
        this.reviewedAt_1 = reviewedAt;
        this.approved_1 = approved;
        this.resultingFamily_1 = resultingFamily;
      }
      toString() {
        var tmp = toString_0(this.reviewedAt_1);
        var tmp_0 = this.resultingFamily_1;
        return 'Review(reviewedAt=' + tmp + ', approved=' + this.approved_1 + ', resultingFamily=' + toString_0(tmp_0 == null ? null : new (ID())(tmp_0)) + ')';
      }
      hashCode() {
        var result = this.reviewedAt_1 == null ? 0 : this.reviewedAt_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.approved_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.resultingFamily_1;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ID__hashCode_impl_f4lulz(this.resultingFamily_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Review()))
          return false;
        if (!equals(this.reviewedAt_1, other.reviewedAt_1))
          return false;
        if (!(this.approved_1 === other.approved_1))
          return false;
        var tmp = this.resultingFamily_1;
        var tmp_0 = tmp == null ? null : new (ID())(tmp);
        var tmp_1 = other.resultingFamily_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID())(tmp_1)))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyApplication_Review_fnqt1j_k$(seen0, reviewedAt, approved, resultingFamily, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_9().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.reviewedAt_1 = null;
        else
          $this.reviewedAt_1 = reviewedAt;
        $this.approved_1 = approved;
        if (0 === (seen0 & 4))
          $this.resultingFamily_1 = null;
        else
          $this.resultingFamily_1 = resultingFamily;
        return $this;
      }
    }
    initMetadataForClass($, 'Review', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    ReviewClass = $;
  }
  return ReviewClass;
}
var IDClass;
function ID_2() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_0(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_2(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_10});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, lazy(tmp_0, FamilyApplication$Companion$$childSerializers$_anonymous__ysr276), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyApplication', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employer', false);
        tmp0_serialDesc.addElement_5pzumi_k$('sentTo', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('invitedUsers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('submission', true);
        tmp0_serialDesc.addElement_5pzumi_k$('review', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['sentTo']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['sentTo', 'employer', 'status', 'createdAt']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-createdAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_iycan9_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_10(), new (ID_2())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_2(), new (ID_0())(value.employer_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.sentTo_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !value.createdAt_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.createdAt_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.invitedUsers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.invitedUsers_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.submission_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_8(), value.submission_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.review_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_9(), value.review_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_iycan9_k$(encoder, value instanceof FamilyApplication() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_10();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = EmailAddressSerializer_getInstance();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (EmailAddress())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_9(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_10();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_2())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_0())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = EmailAddressSerializer_getInstance();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (EmailAddress())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_8(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_9(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FamilyApplication().new_org_thecommunitygroupinc_cares_FamilyApplication_nytiu_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_10(), $serializer_getInstance_2(), EmailAddressSerializer_getInstance(), InstantSerializer_getInstance(), tmp0_cached[4].get_value_j01efc_k$(), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_9())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_11() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var FamilyApplicationClass;
function FamilyApplication() {
  if (FamilyApplicationClass === VOID) {
    class $ {
      constructor(_id, employer, sentTo, createdAt, invitedUsers, submission, review) {
        Companion_getInstance_3();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()) : _id;
        createdAt = createdAt === VOID ? now() : createdAt;
        var tmp;
        if (invitedUsers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = invitedUsers;
        }
        invitedUsers = tmp;
        submission = submission === VOID ? null : submission;
        review = review === VOID ? null : review;
        this._id_1 = _id;
        this.employer_1 = employer;
        this.sentTo_1 = sentTo;
        this.createdAt_1 = createdAt;
        this.invitedUsers_1 = invitedUsers;
        this.submission_1 = submission;
        this.review_1 = review;
      }
      get__id_ukjhy2_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_2())(this.get__id_ukjhy2_k$());
      }
      copy_9zb9a6_k$(_id, employer, sentTo, createdAt, invitedUsers, submission, review) {
        return new (FamilyApplication())(_id, employer, sentTo, createdAt, invitedUsers, submission, review);
      }
      copy$default_e3bxd1_k$(_id, employer, sentTo, createdAt, invitedUsers, submission, review, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        employer = employer === VOID ? this.employer_1 : employer;
        sentTo = sentTo === VOID ? this.sentTo_1 : sentTo;
        createdAt = createdAt === VOID ? this.createdAt_1 : createdAt;
        invitedUsers = invitedUsers === VOID ? this.invitedUsers_1 : invitedUsers;
        submission = submission === VOID ? this.submission_1 : submission;
        review = review === VOID ? this.review_1 : review;
        return $super === VOID ? this.copy_9zb9a6_k$(_id, employer, sentTo, createdAt, invitedUsers, submission, review) : $super.copy_9zb9a6_k$.call(this, new (ID_2())(_id), new (ID_0())(employer), new (EmailAddress())(sentTo), createdAt, invitedUsers, submission, review);
      }
      toString() {
        return 'FamilyApplication(_id=' + ID__toString_impl_y5caka_0(this._id_1) + ', employer=' + ID__toString_impl_y5caka(this.employer_1) + ', sentTo=' + EmailAddress__toString_impl_artjh3(this.sentTo_1) + ', createdAt=' + this.createdAt_1.toString() + ', invitedUsers=' + toString(this.invitedUsers_1) + ', submission=' + toString_0(this.submission_1) + ', review=' + toString_0(this.review_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.employer_1) | 0;
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.sentTo_1) | 0;
        result = imul(result, 31) + this.createdAt_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.invitedUsers_1) | 0;
        result = imul(result, 31) + (this.submission_1 == null ? 0 : this.submission_1.hashCode()) | 0;
        result = imul(result, 31) + (this.review_1 == null ? 0 : this.review_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FamilyApplication()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.employer_1, other.employer_1))
          return false;
        if (!(this.sentTo_1 === other.sentTo_1))
          return false;
        if (!this.createdAt_1.equals(other.createdAt_1))
          return false;
        if (!equals(this.invitedUsers_1, other.invitedUsers_1))
          return false;
        if (!equals(this.submission_1, other.submission_1))
          return false;
        if (!equals(this.review_1, other.review_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyApplication_nytiu_k$(seen0, _id, employer, sentTo, createdAt, invitedUsers, submission, review, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(6 === (6 & seen0))) {
          throwMissingFieldException(seen0, 6, $serializer_getInstance_11().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.employer_1 = employer;
        $this.sentTo_1 = sentTo;
        if (0 === (seen0 & 8))
          $this.createdAt_1 = now();
        else
          $this.createdAt_1 = createdAt;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.invitedUsers_1 = emptySet();
        } else
          $this.invitedUsers_1 = invitedUsers;
        if (0 === (seen0 & 32))
          $this.submission_1 = null;
        else
          $this.submission_1 = submission;
        if (0 === (seen0 & 64))
          $this.review_1 = null;
        else
          $this.review_1 = review;
        return $this;
      }
    }
    initMetadataForClass($, 'FamilyApplication', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_11});
    FamilyApplicationClass = $;
  }
  return FamilyApplicationClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderApplication.Submission', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('submittedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('provider', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_h50zgw_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.submittedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_5(), value.submittedAt_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_3(), value.provider_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_h50zgw_k$(encoder, value instanceof Submission_0() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Submission_0().new_org_thecommunitygroupinc_cares_ProviderApplication_Submission_nojy2s_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_5()), $serializer_getInstance_3()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_12() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderApplication.Review', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('reviewedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('approved', false);
        tmp0_serialDesc.addElement_5pzumi_k$('resultingProvider', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_kc7c78_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.reviewedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_5(), value.reviewedAt_1);
        }
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.approved_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          var tmp_0 = value.resultingProvider_1;
          tmp = !((tmp_0 == null ? null : new (ID_1())(tmp_0)) == null);
        }
        if (tmp) {
          var tmp_1 = $serializer_getInstance_4();
          var tmp_2 = value.resultingProvider_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp_1, tmp_2 == null ? null : new (ID_1())(tmp_2));
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kc7c78_k$(encoder, value instanceof Review_0() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = $serializer_getInstance_4();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_5(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_2 = $serializer_getInstance_4();
                var tmp_3 = tmp6_local2;
                var tmp_4 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (ID_1())(tmp_3));
                tmp6_local2 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Review_0().new_org_thecommunitygroupinc_cares_ProviderApplication_Review_snr5o8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_5()), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_4())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_13() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_6() {
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.ProviderApplication.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(ProviderApplication())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6ahk31_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6ahk31_k$(encoder, value instanceof ID_3() ? value.raw_1 : THROW_CCE());
      }
      deserialize_c4vep2_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_3())(this.deserialize_c4vep2_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_14() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function ID__hashCode_impl_f4lulz_3($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_3()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_3())(other instanceof ID_3() ? other.raw_1 : THROW_CCE()));
}
function ProviderApplication$Companion$$childSerializers$_anonymous__md01f9() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_7());
}
var SubmissionClass_0;
function Submission_0() {
  if (SubmissionClass_0 === VOID) {
    class $ {
      constructor(submittedAt, provider) {
        submittedAt = submittedAt === VOID ? null : submittedAt;
        this.submittedAt_1 = submittedAt;
        this.provider_1 = provider;
      }
      toString() {
        return 'Submission(submittedAt=' + toString_0(this.submittedAt_1) + ', provider=' + this.provider_1.toString() + ')';
      }
      hashCode() {
        var result = this.submittedAt_1 == null ? 0 : this.submittedAt_1.hashCode();
        result = imul(result, 31) + this.provider_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Submission_0()))
          return false;
        if (!equals(this.submittedAt_1, other.submittedAt_1))
          return false;
        if (!this.provider_1.equals(other.provider_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderApplication_Submission_nojy2s_k$(seen0, submittedAt, provider, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_12().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.submittedAt_1 = null;
        else
          $this.submittedAt_1 = submittedAt;
        $this.provider_1 = provider;
        return $this;
      }
    }
    initMetadataForClass($, 'Submission', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
    SubmissionClass_0 = $;
  }
  return SubmissionClass_0;
}
var ReviewClass_0;
function Review_0() {
  if (ReviewClass_0 === VOID) {
    class $ {
      constructor(reviewedAt, approved, resultingProvider) {
        reviewedAt = reviewedAt === VOID ? null : reviewedAt;
        resultingProvider = resultingProvider === VOID ? null : resultingProvider;
        this.reviewedAt_1 = reviewedAt;
        this.approved_1 = approved;
        this.resultingProvider_1 = resultingProvider;
      }
      toString() {
        var tmp = toString_0(this.reviewedAt_1);
        var tmp_0 = this.resultingProvider_1;
        return 'Review(reviewedAt=' + tmp + ', approved=' + this.approved_1 + ', resultingProvider=' + toString_0(tmp_0 == null ? null : new (ID_1())(tmp_0)) + ')';
      }
      hashCode() {
        var result = this.reviewedAt_1 == null ? 0 : this.reviewedAt_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.approved_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.resultingProvider_1;
        if ((tmp_1 == null ? null : new (ID_1())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ID__hashCode_impl_f4lulz_1(this.resultingProvider_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Review_0()))
          return false;
        if (!equals(this.reviewedAt_1, other.reviewedAt_1))
          return false;
        if (!(this.approved_1 === other.approved_1))
          return false;
        var tmp = this.resultingProvider_1;
        var tmp_0 = tmp == null ? null : new (ID_1())(tmp);
        var tmp_1 = other.resultingProvider_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID_1())(tmp_1)))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderApplication_Review_snr5o8_k$(seen0, reviewedAt, approved, resultingProvider, serializationConstructorMarker) {
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_13().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.reviewedAt_1 = null;
        else
          $this.reviewedAt_1 = reviewedAt;
        $this.approved_1 = approved;
        if (0 === (seen0 & 4))
          $this.resultingProvider_1 = null;
        else
          $this.resultingProvider_1 = resultingProvider;
        return $this;
      }
    }
    initMetadataForClass($, 'Review', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
    ReviewClass_0 = $;
  }
  return ReviewClass_0;
}
var IDClass_0;
function ID_3() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_3(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_14});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, lazy(tmp_0, ProviderApplication$Companion$$childSerializers$_anonymous__md01f9), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_7() {
  if (Companion_instance_6 === VOID)
    new (Companion_6())();
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderApplication', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('sentTo', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('invitedUsers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (AdminViewOnly())());
        tmp0_serialDesc.addElement_5pzumi_k$('submission', true);
        tmp0_serialDesc.addElement_5pzumi_k$('review', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTitleFields())(['sentTo']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (AdminTableColumns())(['sentTo', 'createdAt']));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (NaturalSort())(['-createdAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_61wiyg_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_14(), new (ID_3())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.sentTo_1));
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !value.createdAt_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, InstantSerializer_getInstance(), value.createdAt_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.invitedUsers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.invitedUsers_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.submission_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_12(), value.submission_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.review_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, $serializer_getInstance_13(), value.review_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_61wiyg_k$(encoder, value instanceof ProviderApplication() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp11_cached = Companion_getInstance_7().$childSerializers_1;
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_14();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = EmailAddressSerializer_getInstance();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (EmailAddress())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp11_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_12(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_14();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_3())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = EmailAddressSerializer_getInstance();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (EmailAddress())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp11_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_12(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, $serializer_getInstance_13(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProviderApplication().new_org_thecommunitygroupinc_cares_ProviderApplication_sojzgv_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_7().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_14(), EmailAddressSerializer_getInstance(), InstantSerializer_getInstance(), tmp0_cached[3].get_value_j01efc_k$(), get_nullable($serializer_getInstance_12()), get_nullable($serializer_getInstance_13())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_15() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var ProviderApplicationClass;
function ProviderApplication() {
  if (ProviderApplicationClass === VOID) {
    class $ {
      constructor(_id, sentTo, createdAt, invitedUsers, submission, review) {
        Companion_getInstance_7();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$()) : _id;
        createdAt = createdAt === VOID ? now() : createdAt;
        var tmp;
        if (invitedUsers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = invitedUsers;
        }
        invitedUsers = tmp;
        submission = submission === VOID ? null : submission;
        review = review === VOID ? null : review;
        this._id_1 = _id;
        this.sentTo_1 = sentTo;
        this.createdAt_1 = createdAt;
        this.invitedUsers_1 = invitedUsers;
        this.submission_1 = submission;
        this.review_1 = review;
      }
      get__id_yz0kr1_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_3())(this.get__id_yz0kr1_k$());
      }
      toString() {
        return 'ProviderApplication(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', sentTo=' + EmailAddress__toString_impl_artjh3(this.sentTo_1) + ', createdAt=' + this.createdAt_1.toString() + ', invitedUsers=' + toString(this.invitedUsers_1) + ', submission=' + toString_0(this.submission_1) + ', review=' + toString_0(this.review_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this._id_1);
        result = imul(result, 31) + EmailAddress__hashCode_impl_wizg9y(this.sentTo_1) | 0;
        result = imul(result, 31) + this.createdAt_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.invitedUsers_1) | 0;
        result = imul(result, 31) + (this.submission_1 == null ? 0 : this.submission_1.hashCode()) | 0;
        result = imul(result, 31) + (this.review_1 == null ? 0 : this.review_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProviderApplication()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.sentTo_1 === other.sentTo_1))
          return false;
        if (!this.createdAt_1.equals(other.createdAt_1))
          return false;
        if (!equals(this.invitedUsers_1, other.invitedUsers_1))
          return false;
        if (!equals(this.submission_1, other.submission_1))
          return false;
        if (!equals(this.review_1, other.review_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderApplication_sojzgv_k$(seen0, _id, sentTo, createdAt, invitedUsers, submission, review, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(2 === (2 & seen0))) {
          throwMissingFieldException(seen0, 2, $serializer_getInstance_15().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.sentTo_1 = sentTo;
        if (0 === (seen0 & 4))
          $this.createdAt_1 = now();
        else
          $this.createdAt_1 = createdAt;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.invitedUsers_1 = emptySet();
        } else
          $this.invitedUsers_1 = invitedUsers;
        if (0 === (seen0 & 16))
          $this.submission_1 = null;
        else
          $this.submission_1 = submission;
        if (0 === (seen0 & 32))
          $this.review_1 = null;
        else
          $this.review_1 = review;
        return $this;
      }
    }
    initMetadataForClass($, 'ProviderApplication', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_15});
    ProviderApplicationClass = $;
  }
  return ProviderApplicationClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_8() {
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyApplicationSubmitRequest', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submission', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_kfqc3k_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_10(), new (ID_2())(value.id_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_8(), value.submission_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kfqc3k_k$(encoder, value instanceof FamilyApplicationSubmitRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_10();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_10();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_8(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FamilyApplicationSubmitRequest().new_org_thecommunitygroupinc_cares_FamilyApplicationSubmitRequest_2vwnkk_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_10(), $serializer_getInstance_8()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_16() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var FamilyApplicationSubmitRequestClass;
function FamilyApplicationSubmitRequest() {
  if (FamilyApplicationSubmitRequestClass === VOID) {
    class $ {
      constructor(id, submission) {
        this.id_1 = id;
        this.submission_1 = submission;
      }
      toString() {
        return 'FamilyApplicationSubmitRequest(id=' + ID__toString_impl_y5caka_0(this.id_1) + ', submission=' + this.submission_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this.id_1);
        result = imul(result, 31) + this.submission_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FamilyApplicationSubmitRequest()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!this.submission_1.equals(other.submission_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyApplicationSubmitRequest_2vwnkk_k$(seen0, id, submission, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_16().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        $this.submission_1 = submission;
        return $this;
      }
    }
    initMetadataForClass($, 'FamilyApplicationSubmitRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
    FamilyApplicationSubmitRequestClass = $;
  }
  return FamilyApplicationSubmitRequestClass;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_9() {
  return Companion_instance_8;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.FamilyApplicationReviewRequest', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('review', false);
        tmp0_serialDesc.addElement_5pzumi_k$('authorizationRange', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_z42rnk_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_10(), new (ID_2())(value.id_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_9(), value.review_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.authorizationRange_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, $serializer_getInstance_6(), value.authorizationRange_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_z42rnk_k$(encoder, value instanceof FamilyApplicationReviewRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_10();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_10();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_2())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_9(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance_6(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FamilyApplicationReviewRequest().new_org_thecommunitygroupinc_cares_FamilyApplicationReviewRequest_5iauc8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_10(), $serializer_getInstance_9(), get_nullable($serializer_getInstance_6())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_17() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var FamilyApplicationReviewRequestClass;
function FamilyApplicationReviewRequest() {
  if (FamilyApplicationReviewRequestClass === VOID) {
    class $ {
      constructor(id, review, authorizationRange) {
        authorizationRange = authorizationRange === VOID ? null : authorizationRange;
        this.id_1 = id;
        this.review_1 = review;
        this.authorizationRange_1 = authorizationRange;
      }
      toString() {
        return 'FamilyApplicationReviewRequest(id=' + ID__toString_impl_y5caka_0(this.id_1) + ', review=' + this.review_1.toString() + ', authorizationRange=' + toString_0(this.authorizationRange_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this.id_1);
        result = imul(result, 31) + this.review_1.hashCode() | 0;
        result = imul(result, 31) + (this.authorizationRange_1 == null ? 0 : this.authorizationRange_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FamilyApplicationReviewRequest()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!this.review_1.equals(other.review_1))
          return false;
        if (!equals(this.authorizationRange_1, other.authorizationRange_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_FamilyApplicationReviewRequest_5iauc8_k$(seen0, id, review, authorizationRange, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_17().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        $this.review_1 = review;
        if (0 === (seen0 & 4))
          $this.authorizationRange_1 = null;
        else
          $this.authorizationRange_1 = authorizationRange;
        return $this;
      }
    }
    initMetadataForClass($, 'FamilyApplicationReviewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    FamilyApplicationReviewRequestClass = $;
  }
  return FamilyApplicationReviewRequestClass;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_10() {
  return Companion_instance_9;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderApplicationSubmitRequest', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('submission', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_qpae8j_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_14(), new (ID_3())(value.id_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_12(), value.submission_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qpae8j_k$(encoder, value instanceof ProviderApplicationSubmitRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_14();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_14();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_3())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProviderApplicationSubmitRequest().new_org_thecommunitygroupinc_cares_ProviderApplicationSubmitRequest_gjjsor_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_14(), $serializer_getInstance_12()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_18() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var ProviderApplicationSubmitRequestClass;
function ProviderApplicationSubmitRequest() {
  if (ProviderApplicationSubmitRequestClass === VOID) {
    class $ {
      constructor(id, submission) {
        this.id_1 = id;
        this.submission_1 = submission;
      }
      toString() {
        return 'ProviderApplicationSubmitRequest(id=' + ID__toString_impl_y5caka_1(this.id_1) + ', submission=' + this.submission_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this.id_1);
        result = imul(result, 31) + this.submission_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProviderApplicationSubmitRequest()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!this.submission_1.equals(other.submission_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderApplicationSubmitRequest_gjjsor_k$(seen0, id, submission, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_18().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        $this.submission_1 = submission;
        return $this;
      }
    }
    initMetadataForClass($, 'ProviderApplicationSubmitRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
    ProviderApplicationSubmitRequestClass = $;
  }
  return ProviderApplicationSubmitRequestClass;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_11() {
  return Companion_instance_10;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.ProviderApplicationReviewRequest', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('id', false);
        tmp0_serialDesc.addElement_5pzumi_k$('review', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_b7zg0j_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_14(), new (ID_3())(value.id_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_13(), value.review_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_b7zg0j_k$(encoder, value instanceof ProviderApplicationReviewRequest() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_14();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_14();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_3())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ProviderApplicationReviewRequest().new_org_thecommunitygroupinc_cares_ProviderApplicationReviewRequest_v8k6kn_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_14(), $serializer_getInstance_13()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_19() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var ProviderApplicationReviewRequestClass;
function ProviderApplicationReviewRequest() {
  if (ProviderApplicationReviewRequestClass === VOID) {
    class $ {
      constructor(id, review) {
        this.id_1 = id;
        this.review_1 = review;
      }
      toString() {
        return 'ProviderApplicationReviewRequest(id=' + ID__toString_impl_y5caka_1(this.id_1) + ', review=' + this.review_1.toString() + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this.id_1);
        result = imul(result, 31) + this.review_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProviderApplicationReviewRequest()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!this.review_1.equals(other.review_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_ProviderApplicationReviewRequest_v8k6kn_k$(seen0, id, review, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_19().descriptor_1);
        }
        var $this = createThis(this);
        $this.id_1 = id;
        $this.review_1 = review;
        return $this;
      }
    }
    initMetadataForClass($, 'ProviderApplicationReviewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
    ProviderApplicationReviewRequestClass = $;
  }
  return ProviderApplicationReviewRequestClass;
}
//region block: init
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
//endregion
//region block: exports
export {
  Companion_getInstance_3 as Companion_getInstancevgnjncsigc6q,
  Companion_instance_1 as Companion_instance2sj66pqhk0s5j,
  Companion_instance_0 as Companion_instance320a6ll7l9qyv,
  Companion_getInstance_0 as Companion_getInstanceuh3bufkg8gwa,
  Companion_instance_8 as Companion_instance3qgdrppmt617n,
  Companion_instance_7 as Companion_instance1m8froy0l9g5n,
  Companion_getInstance_7 as Companion_getInstance2yczpxlc95n6h,
  Companion_instance_5 as Companion_instances36b4kf4ntme,
  Companion_instance_4 as Companion_instanceebautjfvyshn,
  Companion_instance_3 as Companion_instance2qg1ehow26tib,
  Companion_instance_10 as Companion_instance18ghsn8rlu2k9,
  Companion_instance_9 as Companion_instance2e7hhq61fk0bx,
  ID_2 as ID3eto015dm4eyk,
  Review as Review2bg5dlhln13tr,
  Submission as Submission20cgpazcq90xy,
  FamilyApplicationReviewRequest as FamilyApplicationReviewRequestp06ebvla4x0h,
  FamilyApplicationSubmitRequest as FamilyApplicationSubmitRequest1j7h0hdr0ven1,
  FamilyApplication as FamilyApplication2f6semoy1a9hz,
  ID_3 as ID3deomyff8nvpw,
  Review_0 as Review67dmpz2u77tw,
  Submission_0 as Submission2bovrq8ym2prz,
  ProviderApplicationReviewRequest as ProviderApplicationReviewRequest326rqs1sxt5sx,
  ProviderApplicationSubmitRequest as ProviderApplicationSubmitRequest3hnpihftgb2vb,
  ProviderApplication as ProviderApplicationj6elx51glw3,
};
//endregion

//# sourceMappingURL=applications.mjs.map
